import { data } from "react-router-dom";
import { fetchDataFromBackend } from "../api/api";
import RegistrationResponse from "../DTOs/registrationResponse";
import InvitationResponse from "../DTOs/invitationResponse";

import logger from "../core/utils/logger";

const isSimulation= import.meta.env.VITE_BACKEND_DATA_SIMULATION === "true";

export const RegistrationService = {
    async registerRequest(registrationPayload) {
        try {
            logger.log("Registration payload:", registrationPayload);
            if (isSimulation) {
                logger.log("Simulation mode active: Returning simulated registration response.");
                return RegistrationResponse.fromApiResponse({
                    success: true,
                    message: "Simulated registration successful",
                    organisationId: "sim-org-id-123"
                });
            }
            const response = await fetchDataFromBackend("/Registration/registerUser",{skipAuth:true, method: 'post', data: registrationPayload});
            logger.log("Registration response:", response);
            return RegistrationResponse.fromApiResponse(response);
        }
        catch (error) {
            logger.error("Error registering request:", error);
            throw error;
        }
    },
    async inviteUserRequest(invitationPayload) {
        try {
            if (isSimulation) {
                logger.log("Simulation mode active: Returning simulated invitation response.");
                return InvitationResponse.fromApiResponse({
                    success: true,
                    message: "Simulated invitation sent successfully"
                });
            }
            logger.log("Invitation payload:", invitationPayload);
            const response = await fetchDataFromBackend("/Registration/inviteUser",{skipAuth:false, method: 'post', data: invitationPayload});
            logger.log("Invitation response:", response);
              // Optionally handle HTTP-level errors (if not handled inside fetchDataFromBackend)
        if (!response.success) {
            logger.warn("Backend responded with an error:", response);
            const error = new Error(response.message || "Failed to invite user");
            error.response = { data: response }; // Preserve the full response for Redux
            logger.error("[Service] Throwing error:", error);
            throw error;
        }
            return InvitationResponse.fromApiResponse(response);
        }
        catch (error) {
            logger.error("Error inviting user:", error);
            throw error;
        }


    },
   



};
